module.exports = __webpack_public_path__ + "img/header-logo.ace35c6.png";